import { getReducedTransitDetails } from '@api';
import { getTimeDaysAgo } from '../../Sections/VoyageAnalytics/VoyageUtils';
import { getChunkedArray } from '../../../helpers/helpers';
import { useQuery } from '@tanstack/react-query';

const MAX_IMO_COUNT = 150;

export const useTransitDetails = ({ imos, transitDays = 30 }) => {
  return useQuery({
    queryKey: ['transitDetails', imos, transitDays],
    queryFn: async ({ signal }) => {
      const filterParams = imos.map((imo) => {
        let startDate = getTimeDaysAgo(transitDays);
        return {
          imo: imo,
          startDate,
          endDate: null,
          reductionFactor: 6
        };
      });

      const chunked = getChunkedArray(filterParams, 50);
      const promises = chunked.map((chunk) => getReducedTransitDetails(chunk, signal));
      const responses = await Promise.all(promises);
      return responses.flat();
    },
    retry: false,
    enabled: imos.length > 0 && imos.length <= MAX_IMO_COUNT && !!transitDays
  });
};
